import { post,get } from "./http";
import common from './constants';
let basic = common.interfacePath.serverTestUrl;
// let basicCartUrl = basic + '/cart';
let basicStoreUrl = basic + '/merchant';
export const CartApi = {
    addCart: params => {return post(`${basic}/cart/insert`, params)}, //添加购物车
    getValidCartList: params => { return get(`/cart/listAllValidateCart`,params)}, //有效购物车列表
    getInvalidCartList: params => { return get(basicStoreUrl +`/listAllInvalidateCart`), params}, //失效购物车列表
    delCart: params => { return post(`${basic}/cart/delete`,params) }, //删除购物车
    clearInvalid: params => { return post(basicStoreUrl +`/deleteInvalidGoods`), params}, //清除购物车失效商品
    followProduct: params => { return post(basicStoreUrl + '/newFollow'), params}, //关注商品
    // /order/checkValidateOrder
    checkValidateOrder: params => { return  post(`/order/checkValidateOrder`, params)},//提交订单前校验是否存在客户关系
};
export default CartApi;